module.exports = __webpack_public_path__ + "static/img/02.1c86b76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/events/140219/02.png
// module id = S12G
// module chunks = 0